import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-server-unavailable',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './server-unavailable.component.html',
  styleUrl: './server-unavailable.component.scss'
})
export class ServerUnavailableComponent {
  @Input() titleKey = 'login.ServerUnavailable';
  @Input() subtitleKey = 'login.ServerUnavailableMessage';
  @Input() title?: string;
  @Input() subtitle?: string;

  @Input() primaryLabelKey = 'login.Retry';
  @Input() secondaryLabelKey = 'login.BackToLogin';
  @Input() primaryLabel?: string;
  @Input() secondaryLabel?: string;

  @Input() portalUrl = 'https://p2-innovate.com/offering/zum-connect-customer-portal/';
  @Input() showFooter = true;

  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();
}
